import {
  GET_CUSTOMERS_CHART_SUCCESS,
  GET_CUSTOMERS_CHART_FAILED,
  GET_INVOICE_CHART_SUCCESS,
  GET_INVOICE_CHART_FAILED,
  GET_USER_TAX_INFO_SUCCESS,
  GET_COMPANY_UPDATES_SUCCESS,
  RELEASE_INFO_SEARCH_PAGE_CHANGE,
  INCREMENT_YEAR,
  DECREMENT_YEAR,
  RESET_YEAR,
  GET_INVOICES_SUCCESS,
  SEND_REFERRAL_SUCCESS,
  SEND_REFERRAL_FAILED,
  LOCATION_CHANGE,
  CLOSE_REFERRAL_SNACKBAR,
  EMAIL_REFERRED_OR_REGISTERED,
  GET_REFERRAL_DISCOUNT_BY_EMAIL_SUCCESS,
  CLOSE_DIALOG_DASHBOARD,
  CLOSE_COMPANY_NOTIFICATION_DIALOG,
  OPEN_COMPANY_NOTIFICATION_DIALOG,
  GET_USER_COMPANY_UPDATE_INFO_SUCCESS,
  GET_USER_LIFETIME_INFO_SUCCESS,
  UPDATE_CELEBRATE_STATUS,
  GET_INVOICE_AND_SALARY_DETAIL_MONTHLY_SUCCESS
} from '../constants'

const event = new Date()
const currentYear = event.getFullYear()

const initialState = {
  invoiceChartData: {},
  topCustomers: {},
  invoiceAmountByMonthlyChartData: {},
  userTaxInfo: {},
  releaseInfoSearchRows: [],
  selected: 0,
  year: currentYear,
  invoices: [],
  showSnackBar: false,
  showFailSnackBar: false,
  emailExist: false,
  noCampaign: true,
  showPopup: false,
  showNotiDialog: false,
  notiIsNotRead: [],
  companyNotifications: [],
  total_invoiced_amount: 0,
  reachAnAward: false,
  service_percentage: 0,
  grossSalaryMonthlyChartData: {},
  raisedSalaryMonthlyChartData: {}
}

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INVOICES_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        { invoices: JSON.parse(action.invoices) }
      )

    case GET_CUSTOMERS_CHART_SUCCESS:
      return Object.assign({}, { ...state }, { topCustomers: action.result })

    case GET_CUSTOMERS_CHART_FAILED:
      return Object.assign({}, { ...state }, { ...action.error })

    case GET_INVOICE_CHART_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        { invoiceChartData: action.result }
      )

    case SEND_REFERRAL_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackBar: true,
          showFailSnackBar: false,
          emailExist: false
        }
      )

    case SEND_REFERRAL_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showFailSnackBar: true,
          showSnackBar: false,
          emailExist: false
        }
      )

    case EMAIL_REFERRED_OR_REGISTERED:
      return Object.assign(
        {},
        { ...state },
        { emailExist: true, showSnackBar: false, showFailSnackBar: false }
      )

    case CLOSE_REFERRAL_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackBar: false,
          showFailSnackBar: false,
          emailExist: false
        }
      )

    case GET_INVOICE_AND_SALARY_DETAIL_MONTHLY_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          invoiceAmountByMonthlyChartData: action.monthly_invoicing,
          grossSalaryMonthlyChartData: action.gross_salary,
          raisedSalaryMonthlyChartData: action.raised_salary
        }
      )

    case GET_INVOICE_CHART_FAILED:
      return Object.assign({}, { ...state }, { ...action.error })

    case GET_USER_TAX_INFO_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          userTaxInfo: action.result
        }
      )

    case GET_COMPANY_UPDATES_SUCCESS:
      const data = action.result
      return Object.assign(
        {},
        { ...state },
        {
          releaseInfoSearchRows: data
        }
      )
    case GET_USER_COMPANY_UPDATE_INFO_SUCCESS:
      const data_info = action.result
      const notiIsNotRead = data_info.filter((el) => el.is_read === false)
      return Object.assign(
        {},
        { ...state },
        {
          notiIsNotRead: notiIsNotRead,
          companyNotifications: data_info
        }
      )

    case OPEN_COMPANY_NOTIFICATION_DIALOG:
      return Object.assign(
        {},
        { ...state },
        {
          showNotiDialog: true
        }
      )

    case CLOSE_COMPANY_NOTIFICATION_DIALOG:
      return Object.assign(
        {},
        { ...state },
        {
          showNotiDialog: false,
          selected: 0
        }
      )

    case RELEASE_INFO_SEARCH_PAGE_CHANGE:
      return Object.assign(
        {},
        { ...state },
        { selected: action.selected.selected }
      )
    case INCREMENT_YEAR:
      return Object.assign(
        {},
        { ...state },
        {
          year: state.year + 1
        }
      )
    case DECREMENT_YEAR:
      return Object.assign(
        {},
        { ...state },
        {
          year: state.year - 1
        }
      )
    case RESET_YEAR:
      return Object.assign(
        {},
        { ...state },
        {
          year: currentYear
        }
      )

    case GET_USER_LIFETIME_INFO_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          total_invoiced_amount: action.result.total_invoiced_amount,
          reachAnAward: action.result.celebrate_notify === true ? false : true,
          service_percentage: action.result.service_fee_percentage
        }
      )

    case UPDATE_CELEBRATE_STATUS:
      return Object.assign(
        {},
        { ...state },
        {
          reachAnAward: false
        }
      )

    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackBar: false,
          showFailSnackBar: false,
          emailExist: false,
          // noCampaign: true,
          showPopup: false,
          showNotiDialog: false,
          selected: 0
        }
      )

    // KAS-336 Get referral discount
    case GET_REFERRAL_DISCOUNT_BY_EMAIL_SUCCESS:
      const result = action.data
      let noCampaign
      let showPopup

      if (result === 'Recommended email is not activated the referral code') {
        noCampaign = true
        showPopup = true
      } else if (
        result === 'Recommended email is activated the referral code'
      ) {
        noCampaign = true
        showPopup = false
      } else {
        noCampaign = false
        showPopup = false
      }
      return Object.assign(
        {},
        { ...state },
        {
          noCampaign: noCampaign,
          showPopup: showPopup
        }
      )

    case CLOSE_DIALOG_DASHBOARD:
      return Object.assign(
        {},
        { ...state },
        {
          showPopup: false
        }
      )

    default:
      return state
  }
}

export default dashboardReducer
